import defaultState from './state'
import Vue from 'vue'
export default {
  setIsCallingBudgets: (state, payload) => { state.isCallingBudgets = payload },
  setBudgets: (state, payload) => {
    if (state.currentPage === 1) {
      state.budgets = payload
    } else {
      state.budgets.push(...payload)
    }
  },
  setCurrentBudget: (state, payload) => { state.currentBudget = payload },
  setBudgetsLastPage: (state, payload) => { state.lastPage = payload },
  setBudgetsTotalItems: (state, payload) => { state.totalItems = payload },
  setBudgetsFilters: (state, payload) => {
    state.filters = payload
    state.currentPage = 1
  },
  incrementBudgetsCurrentPage: (state) => state.currentPage++,
  addBudget: (state, payload) => {
    const { id } = payload
    const budgetToFind = state.budgets.findIndex(el => el.id === id)
    if (budgetToFind !== -1) {
      state.budgets.splice(budgetToFind, 1, payload)
    } else {
      state.budgets.unshift(payload)
    }
  },
  updateCurrentBudget: (state, payload) => {
    state.currentBudget = payload
  },
  updateBudgetUserMember: (state, payload) => {
    const { id } = payload
    const memberToFindIndex = state.currentBudget.userBudgets.findIndex(el => el.id === id)
    if (memberToFindIndex !== -1) {
      state.currentBudget.userBudgets.splice(memberToFindIndex, 1, payload)
    }
  },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
